"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRNotifyAsisPlugin = void 0;
const features_1 = require("../../../features");
class XHRNotifyAsisPlugin {
    constructor() {
        this.name = this.constructor.name;
    }
    async handleRequest(request) {
        if (request.method === 'GET') {
            (0, features_1.publishNotifyAsisEvent)(null);
        }
        return Promise.resolve(request);
    }
}
exports.XHRNotifyAsisPlugin = XHRNotifyAsisPlugin;
//# sourceMappingURL=xhrNotifyAsisPlugin.js.map